<template>
  <div>
    <c-card title="수질-자가측정 결과 업로드" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn 
            v-if="editable" 
            label="LBLAPPLY" 
            icon="save"
            @btnClicked="acceptData" />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-3">
          <c-plant :editable="false" type="edit" name="plantCd" v-model="data.plantCd" />
        </div>
        <div class="col-3">
          <c-field
            :editable="false"
            :data="data"
            deptValue="deptCd"
            type="dept_user"
            label="작성부서 & 작성자"
            name="userId"
            v-model="data.userId">
          </c-field>
        </div>
        <div class="col-2">
          <c-datepicker
            :editable="false"
            label="측정일"
            name="measureDt"
            v-model="data.measureDt"
          />
        </div>
        <div class="col-2">
          <c-select
            type="edit"
            :editable="false"
            codeGroupCd="WEATHER_CD"
            itemText="codeName"
            itemValue="code"
            label="날씨"
            name="weatherCd"
            v-model="data.weatherCd">
          </c-select>
        </div>
        <div class="col-2">
          <c-text
            :editable="false"
            label="온도"
            suffix="℃"
            name="temperature"
            v-model="data.temperature">
          </c-text>
        </div>
        <div class="col-3">
          <c-select
            type="edit"
            :editable="false"
            codeGroupCd="WATER_MEASURE_TYPE_CD"
            itemText="codeName"
            itemValue="code"
            label="측정구분"
            name="waterMeasureTypeCd"
            v-model="data.waterMeasureTypeCd">
          </c-select>
        </div>
        <div class="col-3">
          <c-text
            :editable="false"
            label="환경기술인"
            name="envUserName"
            v-model="data.envUserName">
          </c-text>
        </div>
        <div class="col-12">
          <c-text
            :editable="false"
            label="환경기술인 의견"
            name="envRemark"
            v-model="data.envRemark">
          </c-text>
        </div>
      </template>
    </c-card>
    <c-excel-upload 
      :editable="editable"
      :excelUploadInfo="excelUploadInfo"
    />
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'self-water-measure-excel-upload',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          envWaterSelfMeasureMstId: '',
        }
      },
    },
  },
  data() {
    return {
      data: {
        plantCd: null,  // 사업장코드
        envWaterSelfMeasureMstId: '',  // 수질 자가측정 일련번호
        measureDt: '',  // 측정일자
        userId: '',  // 작성자
        deptCd: '',  // 작성부서
        weatherCd: null,  // 날씨
        temperature: '',  // 온도
        waterMeasureTypeCd:null,  // 수질 자가측정구분
        measureVendorName: '',  // 측정업체 또는 측정자
        envUserName: '',  // 환경기술인
        envRemark: '',  // 환경기술인 의견
      },
      headerUrl: '',
      excelUploadInfo: {
        rowKeys: ['envWaterMstMeasurelocName'], // 데이터들의 키 속성값
        taskClassCd: 'ENV_WATER_SELFMEASURE', // 엑셀업로드 양식 구분 값
        sheetNum: 0,
        columns: [[
          {
            name: 'envWaterMstMeasurelocName',
            field: 'envWaterMstMeasurelocName',
            label: '측정위치',
            align: 'center',
            style: 'width: 200px',
            sortable: false,
            fix: true,
          },
        ]],
        data: [],
        deptCd: '',
        processCd: '',
        workplace: '',
      },
      changeItem: {
        plant: '',
        process: '',
        vendor: '',
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    request() {
      return this.$store.getters.user.deptName + ' / ' + this.$store.getters.user.userName + ' / '  + this.$comm.getToday()
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.headerUrl = selectConfig.env.water.self.measureloc.header.url;
      this.getDetail();
      this.getHeader();
    },
    getDetail() {
      if (this.popupParam.envWaterSelfMeasureMstId) {
        this.$http.url = selectConfig.env.water.self.measure.get.url;
        this.$http.param = {envWaterSelfMeasureMstId: this.popupParam.envWaterSelfMeasureMstId}
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = _result.data;
        },);
      }
    },
    getHeader() { 
      this.$http.url = this.headerUrl + '/upload';
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.envWaterMstInspectItemIds = [];
        this.$_.forEach(_result.data, item => {
          this.envWaterMstInspectItemIds.push(item.envWaterMstInspectItemId);
          this.excelUploadInfo.columns[0].push(
            {
              name: item.envWaterMstInspectItemId,
              field: item.envWaterMstInspectItemId,
              type: 'number',
              label: item.envWaterMstInspectItemName,
              align: 'center',
              style: 'width: 90px',
              sortable: false,
            }
          )
        });
      },);
    },
    acceptData() {
      if (this.excelUploadInfo.data) {
        let dataCntCheck = true;
        let errorDataCheck = false;
        if (!this.excelUploadInfo.data[0] || this.excelUploadInfo.data[0].length === 0) {
          dataCntCheck = false;
        }
        if (this.$_.findIndex(this.excelUploadInfo.data[0], (item) => { return item.error_message }) > -1) {
          errorDataCheck = true
        }
        if (!dataCntCheck) {
          window.getApp.$emit('ALERT', {
            title: 'LBLGUIDE', // 안내
            message: '업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.', // 업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.
            type: 'warning', // success / info / warning / error
          });
        } else {
          if (errorDataCheck) {
            window.getApp.$emit('ALERT', {
              title: 'LBLGUIDE', // 안내
              message: '에러가 있는 데이터가 존재합니다.\n\r데이터 확인 후 적용하시길 바랍니다.', // 업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.
              type: 'warning', // success / info / warning / error
            });
            // window.getApp.$emit('CONFIRM', {
            //   title: 'LBLCONFIRM',
            //   message: '에러가 있는 데이터가 존재합니다.\n\r에러 있는 데이터를 제외한 나머지 데이터를 적용하시겠습니까?',
            //   // TODO : 필요시 추가하세요.
            //   type: 'info', // success / info / warning / error
            //   // 확인 callback 함수  
            //   confirmCallback: () => {
            //     this.$emit('closePopup', this.excelUploadInfo.data[0]);
            //   },
            //   // 취소 callback 함수
            //   cancelCallback: () => {
            //   },
            // });
          } else {
            window.getApp.$emit('CONFIRM', {
              title: 'LBLCONFIRM',
              message: '해당 엑셀데이터를 업로드하면,\n\r기존에 저장된 자가측정데이터를 초기화 한 후에 저장됩니다.\n\r그대로 적용하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수  
              confirmCallback: () => {
                this.$emit('closePopup', this.excelUploadInfo.data[0]);
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        }
      }
    }
  }
};
</script>
